import { SurveyItemBox } from "style/inspect";
import { answerOptions } from "utils/datas";

interface DataProps {
  question: string;
  imgPath: string;
  handleAnswerSelect: (value: number) => void;
  index: number;
}

const InspectSurveyItem = ({
  question,
  imgPath,
  handleAnswerSelect,
  index,
}: DataProps) => {
  return (
    <SurveyItemBox>
      <div className="index-box">
        <span>{index}</span>
        <span>/</span>
        <span>10</span>
      </div>
      <div className="m">
        <div className="question-box">
          <p className="question">{question}</p>
        </div>
        <div className="img-box">
          <img src={imgPath} alt="" />
        </div>
      </div>
      <div className="survey-answer-box">
        {answerOptions.map((item) => (
          <button
            key={item.value}
            type="button"
            data-value={item.value}
            onClick={() => {
              handleAnswerSelect(item.value); // ✅ 부모로 선택한 값 전달
            }}
          >
            {item.label}
          </button>
        ))}
      </div>
    </SurveyItemBox>
  );
};

export default InspectSurveyItem;
